import Icon1 from "../assets/icons/Icon";
import imageLogo from "../assets/icon.png"; // Adjust the path as necessary
import { Player } from "@lottiefiles/react-lottie-player";
import loadingAnimation from "../animations/loading.json"; // Path to your JSON file

export const Loading = () => {
  return (
    <div className="h-screen flex flex-col gap-2 bg-black fixed w-screen items-center justify-center"></div>
  );
  return (
    <div className=" fixed top-0 left-0 flex-col items-center bg-black justify-center h-screen w-screen ">
      <div className="w-full h-full relative flex justify-center items-center ">
        <div className="absolute z-20 flex flex-col gap-2 items-center justify-center">
          <img className=" z-10 w-24" src={imageLogo} alt="Logo" />
          <div
            style={{
              fontSize: "2rem",
              lineHeight: "2rem",
            }}
            className=" font-extrabold text-white text-center  "
          >
            easy vmc
          </div>
          <Player
            autoplay
            loop
            src={loadingAnimation}
            className="w-c200 h-auto"
          />
        </div>

        <img
          src="https://i.pinimg.com/1200x/59/d4/73/59d4737cb52c2d989eebbc524f033c5c.jpg"
          alt="Background"
          className="w-full h-full object-cover  absolute"
        />
      </div>
    </div>
  );
};
